const initialState = {
  account: null,
  status: {
    isLoading: true
  }
}

const setLoading = (state, isLoading) => ({
  ...state,
  status: {
    isLoading
  }
})

const startLoading = (state) => setLoading(state, true)
const stopLoading = (state) => setLoading(state, false)

const accountLoaded = (state, {
  email,
  access_granted: accessGranted,
  connection_type: connectionType
}) => ({
  ...state,
  status: {
    isLoading: false
  },
  account: {
    email,
    accessGranted,
    connectionType
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'MICROSOFT_TEAMS_FETCH_ACCOUNT':
      return startLoading(state)
    case 'MICROSOFT_TEAMS_FETCH_ACCOUNT_SUCCESS':
      return accountLoaded(state, payload)
    case 'MICROSOFT_TEAMS_FETCH_ACCOUNT_COMPLETE':
      return stopLoading(state)
    case 'MICROSOFT_TEAMS_DISCONNECT_SUCCESS':
      return { ...state, ...stopLoading(initialState) }
    default:
      return { ...initialState, ...state }
  }
}
